import React, { useEffect } from 'react'
import { Link } from 'react-router-dom';
import $ from 'jquery'
import OwlCarousel from 'react-owl-carousel'
import '../assets/owl carousel/owl.carousel.min.css'
import '../assets/owl carousel/owl.theme.default.min.css'
import useRippleEffect from '../hooks/useRippleEffect';
// Components
import PageTransition from '../components/PageTransition';
import CourseCard from '../components/CourseCard';
import ProductCard from '../components/ProductCard';
import ServiceCard from '../components/ServiceCard';
import ReviewCard from '../components/ReviewCard';
// CSS
import '../assets/css/home.css';

export default function Home() {
  useRippleEffect();

  useEffect(() => {
    localStorage.removeItem('login_redirect_url');
  }, []);

  return (
    <div className="home_page page_body pd_n">
      <PageTransition />
      
      <header>
        <div className='container'>
          <div className="intro">
            <h1><span>ঘরে বসে</span> পড়াশুনা<br/>চাইলেই সম্ভব !</h1>
            <p>ওয়েব ডেভেলপমেন্ট, এপ ডেভেলপমেন্ট, ডিজিটাল মার্কেটিং সহ ক্যারিয়ার পাথ প্রোগ্রাম ও আরোও স্কিল ফুল কোর্স গুলো করে<br/>নিজের দক্ষতা কে রাখুন কয়েক ধাপ এগিয়ে।</p>
            <Link to="/courses" className="btn_primary bx_shadow bg-2 ripple-animate ripple-light">কোর্সসমূহ  →</Link>
          </div>
          <div className="slider">
            <OwlCarousel
              dots={true}
              className='owl-theme'
              items={1}
              autoPlay={true}
              autoplayHoverPause={true}
              autoplaySpeed={1000}
              loop={true}
            >
              <Link to='/course/full-stack-web-development' className='item'>
                <img src={require('../assets/images/slider banners/banner-01.png')} alt="banner" />
              </Link>
              <Link to='course/basic-c-programming' className='item'>
                <img src={require('../assets/images/slider banners/banner-02.png')} alt="banner" />
              </Link>
              <Link to='' className='item'>
                <img src={require('../assets/images/slider banners/banner-03.png')} alt="banner" />
              </Link>
              <Link to='' className='item'>
                <img src={require('../assets/images/slider banners/banner-04.png')} alt="banner" />
              </Link>
              <Link to='' className='item'>
                <img src={require('../assets/images/slider banners/banner-05.png')} alt="banner" />
              </Link>
            </OwlCarousel>
          </div>
        </div>
      </header>
        
      <div className="container pd-n">
        <section className="courses">
          <div className="section_title_default select_n">টপ কোর্সসমূহ</div>
          <p className="section_description">দেশের স্বনামধন্য মেন্টরদের দ্বারা পরিচালিত কোর্স গুলো এনরোল করুন আজই।</p>
          
          <div className="courses_container">
            <CourseCard
              thumbnail={require('../assets/images/course banners/banner-01.png')}
              title="প্রফেশনাল ফুল স্ট্যাক ওয়েব ডেভেলপমেন্ট কোর্স"
              mentors={[{mentorImage: require('../assets/images/mentor.jpg'), mentorName: 'মেন্টর নাম'}]}
              mainPrice=""
              discountPrice=""
              labels={["kdfjdkf"]}
            />
          </div>
          

          <Link to="/courses" className="see_all_btn btn_primary btn_hover bg-2 ripple-animate ripple-dark">See All</Link>
        </section>

        <section className="products">
          <div className="section_title_default select_n">আমাদের প্রোডাক্টসমূহ</div>
          <div className="products_container">
            <ProductCard 
              thumbnail={require('../assets/images/book banners/banner-01.png')} 
              name="Web Design PDF Book by- Shafkat Jahan"
              mainPrice="২৫০"
              discountPrice="১০০"
              inCart={false} 
            />
            <ProductCard 
              thumbnail={require('../assets/images/book banners/banner-02.png')} 
              name="Fiverr Success PDF Book by- Saidur Rahman Shuvo"
              discountPrice="Free"
              inCart={false} 
            />
          </div>

          <Link to="/products" className="see_all_btn btn_primary btn_hover bg-2 ripple-animate ripple-light">See All</Link>
        </section>
        
        <section className="services">
          <div className="section_title_default center select_n"><span>"</span>আমাদের প্রচেষ্টা<span>"</span></div>
          <div className="services_container">
            <ServiceCard 
              icon={require('../assets/icons/record.png')} 
              title="Class Records" 
              description="We provide all the recordings of the live classes on Google Drive. So that the students can do the or revise the class later." 
            />
            <ServiceCard 
              icon={require('../assets/icons/lifetime-support.png')} 
              title="Lifetime Support" 
              description="CodoHov's students with a student badge will be provided lifetime support. It means they will be helped in any code solution or tutorial for a lifetime." 
            />
            <ServiceCard 
              icon={require('../assets/icons/project.png')} 
              title="Live Projects" 
              description="Students will be offered live projects that will be done in some live classes with the students for improving their project building skills and to solve their problems easily." 
            />
            <ServiceCard 
              icon={require('../assets/icons/career.png')} 
              title="Career Guideline" 
              description="During our course session, we provide career guidance to our students. We will help them to find their dream job in those fields and to get a job." 
            />
            <ServiceCard 
              icon={require('../assets/icons/freelancing.png')} 
              title="Freelancing Guideline" 
              description="Students will be provided with a freelancing guideline to earn money by freelancing from international marketplaces such as Fiverr and Upwork." 
            />
            <ServiceCard 
              icon={require('../assets/icons/internship.png')} 
              title="Internship Chance" 
              description="We will provide our students with an internship chance to get an internship from our IT company HovSofts. If the students do well in their course sessions they will be offered this internship opportunity."
            />
          </div>
        </section>
        
        <section className="reviews">
          <div className="section_title_default select_n">পাবলিক রিভিউস</div>

          <div className="reviews_container">
            <ReviewCard 
              reviewerImage=''
              reviewerName="Forhad Hossain"
              bio="IT Entrepreneur"
              reviewText="Friendly teachers and straight to the point lectures. Overall a good institute to learn Coding and Freelancing. Highly recommended for the people who want a complete guideline in this field." 
            />
            <ReviewCard 
              reviewerImage=''
              reviewerName="Mîñhåz Ñïr"
              bio="Software Developer"
              reviewText="I'm a batch 4th student. They provide awesome live classes and daily tasks with live projects. I'm still learning Full Stack Web Development in this page. Highly Recomended." 
            />
            <ReviewCard 
              reviewerImage=''
              reviewerName="Faruk Hossain"
              bio="Imam"
              reviewText="Best Institute for Freelancing. Quality Content!" 
            />
          </div>
        </section>
      </div>
    </div>
  )
}
